import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Select, { ValueType } from 'react-select';
import { subscribeListener, unsubscribeListener } from 'redux/ably/sagas';
import { styled } from '../../assets/theme';
import { TftfSelect, DataContainer, LabeledText } from '../../assets/theme/StyledComponents';
import { CompactView } from './components/CompactView';
import { DetailsView } from './components/DetailsView';
import { HistoricalStMomoTrades } from './components/HistoricalStMomoTrades';

import { getEventsAudioIsMuted } from '../../redux/events/selectors';

interface IWatchboxInstrument {
  label: string,
  value: string
}

const items: IWatchboxInstrument[] = [
  // { label: 'NDX - 1Min', value: 'NDX1' },
  // { label: 'NDX - 5Min', value: 'NDX5' },
  // { label: 'NDX - 60Min', value: 'NDX60' },
  // { label: 'NDX - 1Day', value: 'NDX1D' },
  // { label: 'SPX - 1Min', value: 'SPX1' },
  // { label: 'SPX - 5Min', value: 'SPX5' },
  // { label: 'SPX - 60Min', value: 'SPX60' },
  // { label: 'SPX - 1Day', value: 'SPX1D' },
  { label: 'ES 1', value: 'ES1' },
  { label: 'ES 5', value: 'ES5' },
  { label: 'ES 5F', value: 'ES5F' },
  { label: 'ES 60', value: 'ES60' },
  { label: 'ES 60F', value: 'ES60F' },
  // { label: 'ES - 1Day', value: 'ES1D' },
  { label: 'NQ 1', value: 'NQ1' },
  { label: 'NQ 5', value: 'NQ5' },
  { label: 'NQ 5F', value: 'NQ5F' },
  { label: 'NQ 60', value: 'NQ60' },
  { label: 'NQ 60F', value: 'NQ60F' },
  // { label: 'NQ - 1Day', value: 'NQ1D' },
  { label: 'ZB 1', value: 'ZB1' },
  { label: 'ZB 5', value: 'ZB5' },
  { label: 'ZB 5F', value: 'ZB5F' },
  { label: 'ZB 60', value: 'ZB60' },
  { label: 'ZB 60F', value: 'ZB60F' },
  // { label: 'ZB - 1Day', value: 'ZB1D' },
  { label: 'ZN 1', value: 'ZN1' },
  { label: 'ZN 5', value: 'ZN5' },
  { label: 'ZN 5F', value: 'ZN5F' },
  { label: 'ZN 60', value: 'ZN60' },
  { label: 'ZN 60F', value: 'ZN60F' },
  // { label: 'ZN - 1Day', value: 'ZN1D' },
  { label: 'CL 1', value: 'CL1' },
  { label: 'CL 5', value: 'CL5' },
  { label: 'CL 5F', value: 'CL5F' },
  { label: 'CL 60', value: 'CL60' },
  { label: 'CL 60F', value: 'CL60F' },
  // { label: 'CL - 1Day', value: 'CL1D' },
];

// const optionRenderer = (option: IWatchboxInstrument) => <div>{option.label}</div>;

interface IWatchboxConfig {
  websocketKey: string,
  symbol: string
}

export interface IWatchboxData {
  active_name?: string,
  active_price?: number,
  active_tgt?: number,
  buy_p_price?: number,
  buy_p_tgt?: number,
  sell_p_price?: number,
  sell_p_tgt?: number,
  active_stop?: number,
  active_time?: Date,
  time?: Date,
  stopout_price?: number,
}

const WatchBoxItem: React.FunctionComponent<{id: number, audioIsMuted: boolean, handleRemoveWidget?: (id: number) => void}> = ({ id, audioIsMuted, handleRemoveWidget }) => {
  const [currentView, setCurrentView] = useState<'compact' | 'expanded' | 'stmomo'>('compact')
  const [watchboxData, setWatchboxData] = useState<IWatchboxData>();
  const [watchboxConfig, setWatchboxConfig] = useState<IWatchboxConfig>({ symbol: 'ES', websocketKey: 'ES1' });

  useEffect(() => {
    const config = localStorage.getItem(`wbitem-${id}`)
    if (config) {
      setWatchboxConfig(JSON.parse(config));
    }
  }, [id])

  useEffect(() => {
    subscribeListener(`watchbox:VPM${watchboxConfig.websocketKey}`, id, ({ data }) => {
      setWatchboxData(data);
    });
    return () => unsubscribeListener(`watchbox:VPM${watchboxConfig.websocketKey}`, id);
  }, [watchboxConfig, id]);

	const onSelectChanged = (item: ValueType<IWatchboxInstrument, false>) => {
    if (!item) { return; }
    if (Array.isArray(item)) { return; }
    const selectedItem = item as IWatchboxInstrument
    const selectedSymbol = selectedItem.label.split(' ')[0];
    const newConfig = {
      symbol: selectedSymbol,
      websocketKey: selectedItem.value
    }
    localStorage.setItem(`wbitem-${id}`, JSON.stringify(newConfig))
    setWatchboxConfig(newConfig)
  };

  const changeViewStateCallback = (view: 'compact' | 'expanded' | 'stmomo') => {
    setCurrentView(view);
  }

  const handleRemoveButtonClicked = (e: React.MouseEvent<HTMLButtonElement>) => {
    const idToRemove = e.currentTarget.dataset.id
    if (idToRemove && handleRemoveWidget) {
      handleRemoveWidget(parseInt(idToRemove, 10))
    }
  }

  const handleExpandButtonClicked = () => {
    if (currentView === 'compact') {
      setCurrentView('expanded')
    } else {
      setCurrentView('compact')
    }
  }

  // const handleWatchboxDataSimulate = () => {
  //   setWatchboxData({
  //   active_name: Math.random() > 0.5 ? 'SELL RALLY' : 'BUY DIP',
  //   active_price: 20,
  //   active_tgt: 30,
  //   buy_p_price: 40,
  //   buy_p_tgt: 50,
  //   sell_p_price: 60,
  //   sell_p_tgt: 70,
  //   });
  // }

  return (
    currentView === 'expanded' ?
      <div style={{ display: 'grid', justifyContent: 'center' }}>
        <GhostButton onClick={handleExpandButtonClicked}>
          <FontAwesomeIcon size="1x" icon={faSignOutAlt} title="Minimize" />
        </GhostButton>
        <DetailsView />
      </div>
      :
      currentView === 'compact' ?
      <div style={{ display: 'grid', justifyContent: 'center' }}>
        <WatchBox>
          <WatchBoxHeader>
            <LabeledText>&nbsp;</LabeledText>
            <TftfSelect>
            <Select<IWatchboxInstrument>
              placeholder="Choose a symbol"
              className="react-select"
              classNamePrefix="react-select"
              value={items.find(item => item.value === watchboxConfig.websocketKey)}
              options={items}
              isClearable={false}
              onChange={onSelectChanged} />
            </TftfSelect>
            {/* <GhostButton onClick={handleExpandButtonClicked}>
              <FontAwesomeIcon size="1x" icon={faSignOutAlt} title="Minimize" />
            </GhostButton> */}
            {handleRemoveWidget?
            <GhostButton onClick={handleRemoveButtonClicked} data-id={id}>
              <FontAwesomeIcon style={{ cursor: 'pointer', opacity: 0.8 }} size="1x" icon={faTimesCircle} title="Close" />
            </GhostButton>
            :
            <span />
          }
          </WatchBoxHeader>
          <CompactView audioIsMuted={audioIsMuted} viewChangeCallback={changeViewStateCallback} id={id} symbol={watchboxConfig.symbol} instrument={watchboxConfig.websocketKey} watchboxData={watchboxData} />
          {/* Simulate a random but or sell signal to assist in design work and testing */}
          {/* <button onClick={handleWatchboxDataSimulate}>
            Simulate
          </button> */}
        </WatchBox>
      </div>
      :
      currentView === 'stmomo' ?
      <div style={{ display: 'grid', justifyContent: 'center', height: '100%' }}>
      <WatchBox style={{ gridTemplateRows: 'auto 1fr'}}>
          <WatchBoxHeader>
            <GhostButton onClick={handleExpandButtonClicked}>
              <FontAwesomeIcon size="1x" icon={faSignOutAlt} title="Minimize" flip="horizontal" />
            </GhostButton>
          </WatchBoxHeader>
          <HistoricalStMomoTrades instrument={watchboxConfig.websocketKey} id={id} />
        </WatchBox>
      </div>
      :
      <div />
  );
};

interface IGhostButtonProps {
  accent? : {
    base: string,
    darker: string
  }
}

const GhostButton = styled.button<IGhostButtonProps>`
  border: none;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ accent }) => accent ? accent.base : 'initial'};
  &:focus {
    outline: none;
  }

  :hover {
    cursor: pointer;
  }
  :disabled {
    background-color: gray;
  }
`;

const WatchBox = styled(DataContainer)`
  width: 360px;
  display: grid;
  grid-auto-flow: row;
  grid-gap: 1em;
  .Select {
    width: 150px;
    margin-top: 10px;
  };
  .Select-control {
    background-color: initial;
    color: ${({ theme }) => theme.core.textColor} !important;
  };
  .Select-value-label {
    color: ${({ theme }) => theme.core.textColor} !important;
  };
  .Select.is-open > .Select-control {
    background-color: initial !important;
  }
  .Select.is-focused:not(.is-open) > .Select-control {
    background-color: initial !important;
  }
`;

const WatchBoxHeader = styled(DataContainer)`
  display: grid;
  grid-template-columns: auto 1fr auto auto;
  justify-items: center;
  grid-gap: 1em;
  align-items: start;
`;

const mapStateToProps = (state: any) => ({
  audioIsMuted: getEventsAudioIsMuted(state),
});

export default connect(mapStateToProps)(WatchBoxItem)
